<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :cell-class-name="cellClassName"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.amzStoreStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_amzStoreStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.amzStoreCode },
                  query: { amzStoreNo: row.amzStoreNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="allow('M') && row.amzStoreStatus === 'Y'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.amzStoreCode },
                  query: { amzStoreNo: row.amzStoreNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="allow('D') && row.amzStoreStatus === 'Y'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayStoreNo="{ row }">
        <span>NO：</span><span>{{ row.amzStoreNo }}</span>
        <br />
        <span>NAME：</span
        ><span style="color: #303133">{{ row.amzStoreName }}</span>
      </template>
      <template v-slot:displayStoreName="{ row }">
        <span>ACCT：</span>
        <span style="color: #303133">{{ row.amzStoreAccount }}</span>
        <br />
        <span>SITE：</span>
        <span style="color: #303133">{{ row.amazonStoreRegionName }}</span>
        <br />
        <span>CNTY：</span>
        <span style="color: #303133">{{ row.regionName }}</span>
      </template>
      <template v-slot:displayEcomCompanyName="{ row }">
        <span>ID：</span>
        <span style="color: #303133">{{ row.amzStoreId }}</span>
        <br />
        <span style="color: #303133">{{ row.ecomCompanyName }}</span>
      </template>
      <template v-slot:displayInvStoreName="{ row }">
        <span>{{ row.invStoreName }}</span>
        <br />
        <span>Own Inv:</span>
        <el-tag
          size="mini"
          class="ml-1"
          :type="row.isOwnInv === 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_isOwnInv }}
        </el-tag>
        <br />
        <span>Currency：</span>
        <span style="color: #303133">{{ row.v_currency }}</span>
        <br />
      </template>
      <template v-slot:displayCreditCard="{ row }">
        <span>Holder:</span>
        <span style="color: #303133">{{ row.creditCardHolder }}</span>
        <br />
        <span>No:</span>
        <span style="color: #303133">{{ row.creditCardNo }}</span>
        <br />
        <span>Expiry:</span>
        <span style="color: #303133">{{ row.expiryYearMonth }}</span>
      </template>

      <template v-slot:displayMobile="{ row }">
        <span>Mobile:</span>
        <span style="color: #303133">{{ row.loginMobile }}</span>
        <br />
        <span>Properties:</span>
        <span style="color: #303133">{{ row.mobileProperties }}</span>
        <br />
        <span>Ownership:</span>
        <span style="color: #303133">{{ row.mobileOwnership }}</span>
        <br />
        <span>Model:</span>
        <span style="color: #303133">{{ row.mobileModel }}</span>
      </template>
      <template v-slot:displayIP="{ row }">
        <span>Address:</span>
        <span style="color: #303133">{{ row.ipAddress }}</span>
        <br />
        <span>Country:</span>
        <span style="color: #303133">{{ row.ipCountry }}</span>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    cellClassName({ column }) {
      const { property } = column
      return property === 'col-opt' ? '' : 'align-top'
    },
    del({ amzStoreCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomAmzStoreDelApi({ amzStoreCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
